import { IVMSConstants, VMSArrayConstantType, VMSMappedObjectConstantsType, VMSStringConstantsType } from "@/constants";
import VMSConstants from "VMSConstants";

export const useConstants = (
  type: "STRING" | "MAPPED" | "ARRAY",
): VMSMappedObjectConstantsType | VMSStringConstantsType | VMSArrayConstantType | null => {
  const loadedConstants: IVMSConstants = VMSConstants as IVMSConstants;

  if (type === "STRING") {
    return loadedConstants.string as VMSStringConstantsType;
  }
  if (type === "MAPPED") {
    return loadedConstants.mapped as VMSMappedObjectConstantsType;
  }
  if (type === "ARRAY") {
    return loadedConstants.array as VMSArrayConstantType;
  }
  return null;
};
